import { render, staticRenderFns } from "./AyinDetailsApp.vue?vue&type=template&id=def6dd16&scoped=true"
import script from "./AyinDetailsApp.vue?vue&type=script&lang=js"
export * from "./AyinDetailsApp.vue?vue&type=script&lang=js"
import style0 from "./AyinDetailsApp.vue?vue&type=style&index=0&id=def6dd16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "def6dd16",
  null
  
)

export default component.exports